export const COUNTRY_CODES: Record<string, string> = {
  ae: "United Arab Emirates",
  at: "Austria",
  au: "Australia",
  be: "Belgium",
  br: "Brazil",
  ca: "Canada",
  ch: "Switzerland",
  cn: "China",
  cz: "Czech Republic",
  de: "Germany",
  dk: "Denmark",
  ee: "Estonia",
  es: "Spain",
  fi: "Finland",
  fr: "France",
  gb: "United Kingdom",
  hk: "Hong Kong",
  ie: "Ireland",
  il: "Israel",
  in: "India",
  it: "Italy",
  jp: "Japan",
  kr: "South Korea",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  mx: "Mexico",
  my: "Malaysia",
  nl: "Netherlands",
  no: "Norway",
  nz: "New Zealand",
  pl: "Poland",
  pt: "Portugal",
  qa: "Qatar",
  ro: "Romania",
  sa: "Saudi Arabia",
  se: "Sweden",
  sg: "Singapore",
  th: "Thailand",
  us: "United States",
  za: "South Africa",
};

export function countryName(code: string): string {
  return COUNTRY_CODES[code.toLowerCase()] ?? code.toUpperCase();
}

export const COUNTRY_OPTIONS = Object.entries(COUNTRY_CODES)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name));
